import { ChartPosition } from '../../util';
import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { AxisIndicatorLayerSpecification, ChartFeature } from '../chart-props';
import { getAxisRect } from '../helpers';

export function drawAxisIndicatorLayer(
    pass: DrawPass,
    features: ChartFeature[],
    layer: AxisIndicatorLayerSpecification,
    xAxis: Axis,
    yAxis: Axis
) {
    if (features.length === 0) {
        return;
    }

    const value = typeof layer.layout.value === 'function' ? layer.layout.value(features) : layer.layout.value;
    const text = typeof layer.layout.text === 'function' ? layer.layout.text(features) : layer.layout.text;
    const offset = layer.layout.offset ?? 0;

    if (layer.layout.axis === 'x') {
        const rect = getAxisRect(xAxis.getProps().position, pass).translate(0, offset);

        const projected = xAxis.project(value, pass.viewState);
        if (!rect.contains(projected, rect.bottom)) {
            return;
        }
        if (xAxis.getProps().position === ChartPosition.top) {
            pass.drawer.drawTriangle(
                [projected, rect.bottom],
                { width: 12, height: 12 },
                {
                    color: layer.paint.fillColor
                },
                undefined,
                180
            );

            pass.drawer.drawTextRect(
                text,
                [projected, rect.bottom - 4 - 12],
                {
                    alignment: 'center',
                    baseline: 'bottom'
                },
                {
                    textColor: layer.paint.textColor,
                    fillColor: layer.paint.fillColor,
                    padding: 4
                }
            );
        } else {
            pass.drawer.drawTriangle(
                [rect.left, projected],
                { width: 12, height: 12 },
                {
                    color: layer.paint.fillColor
                },
                undefined,
                -90
            );
            pass.drawer.drawTextRect(
                text,
                [rect.left + 16 + 2, projected],
                {
                    alignment: 'left',
                    baseline: 'middle'
                },
                {
                    textColor: layer.paint.textColor,
                    fillColor: layer.paint.fillColor,
                    padding: 4
                }
            );
        }
    } else {
        const projected = yAxis.project(value, pass.viewState);
        const rect = getAxisRect(yAxis.getProps().position, pass).translate(offset, 0);
        if (!rect.contains(rect.left, projected)) {
            return;
        }

        if (yAxis.getProps().position === ChartPosition.left) {
            pass.drawer.drawTriangle(
                [rect.right, projected],
                { width: 12, height: 12 },
                {
                    color: layer.paint.fillColor
                },
                undefined,
                90
            );

            pass.drawer.drawTextRect(
                text,
                [rect.right - 16 - 2, projected],
                {
                    alignment: 'right',
                    baseline: 'middle'
                },
                {
                    textColor: layer.paint.textColor,
                    fillColor: layer.paint.fillColor,
                    padding: 4
                }
            );
        } else {
            pass.drawer.drawTriangle(
                [rect.left, projected],
                { width: 12, height: 12 },
                {
                    color: layer.paint.fillColor
                },
                undefined,
                -90
            );
            pass.drawer.drawTextRect(
                text,
                [rect.left + 16 + 2, projected],
                {
                    alignment: 'left',
                    baseline: 'middle'
                },
                {
                    textColor: layer.paint.textColor,
                    fillColor: layer.paint.fillColor,
                    padding: 4
                }
            );
        }
    }
}
